import type { VaultDocument, VaultDocumentPort } from '../domain/document'

const updateDocumentTags = async (port: VaultDocumentPort, documentId: string, tags: string[]): Promise<VaultDocument> =>
	port.updateTags(documentId, tags)

export { updateDocumentTags }
